import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'service_order_attachment';

export default {
  async create(serviceOrderId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/attachment`);
    return api.post(url, data);
  },
  async search(queryParams) {
    const url = mountUrl(`/${BASE_PATH}`, queryParams);
    return api.get(url);
  },
  async getById(id) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.get(url);
  },
  async update(id, data) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.put(url, data);
  },
  async inactivate(serviceOrderId, id) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/${id}`);
    return api.delete(url);
  }
};
